import styled from 'styled-components';
import { MBox } from '../MBox';

export const StyledImageCarouselCon = styled(MBox)`
  position: relative;
  overflow: hidden;

  & .mr-images-carousel__images-grid {
    overflow-x: auto;
  }

  & .mr-images-carousel__carousel-con {
    width: ${props => props.imageWidth}px;
    height: ${props => props.imageHeight}px;

    & .react-multiple-carousel__arrow {
      opacity: 0;
      background: #ffffff;
      min-height: 20px;
      min-width: 20px;
      padding: 0px;

      &::before {
        width: 9px;
        height: 9px;
        position: absolute;
        top: 50%;
        left: 50%;
        border-color: ${props => props.arrowColor};
      }

      &:hover {
        background: #ffffff;
      }

      &--right {
        right: 4px;

        &::before {
          transform: translate(-65%, -50%) rotate(45deg);
        }
      }

      &--left {
        left: 4px;

        &::before {
          transform: translate(-35%, -50%) rotate(45deg);
        }
      }
    }

    &:hover {
      & .react-multiple-carousel__arrow {
        opacity: 1;
      }
    }
  }
`;

export const StyledImageCarouselOverlay = styled(MBox)`
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
`;
